import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
} from "@mui/material";
import { AppendIfPrefixExists } from "../../../../modules/sitePaths";
import React, { Fragment } from "react";
import { NavLinkStyles } from "../styles/NavigationStyles";
import { NavItemType } from "./NavigationTypes";
import { telemetryProps } from "shared-ui/src/instrumentation/gtm";

interface NavFunctionProps {
  navItem: NavItemType;
  tier: number;
  parentContext: string;
}
export default function NavFunction({
  navItem,
  tier,
  parentContext,
}: NavFunctionProps) {
  const theme = useTheme();
  const styles = NavLinkStyles(theme);

  if (!navItem.visible) {
    return <Fragment />;
  }
  return (
    <>
      <ListItemButton
        sx={[tier === 2 ? styles.nested : {}, tier === 3 ? styles.nested2 : {}]}
        onClick={() => (navItem.function ? navItem.function() : null)}
        href={AppendIfPrefixExists(navItem.path)}
        {...telemetryProps({
          name: "nav_function",
          section: "navigation",
          label: `${parentContext} > ${navItem.displayName}`,
          id: navItem.id,
        })}
      >
        {navItem.icon && (
          <ListItemIcon sx={styles.listItemIcon}>{navItem.icon}</ListItemIcon>
        )}
        <ListItemText
          primary={navItem.displayName}
          sx={tier === 1 ? styles.listItemText : {}}
        />
      </ListItemButton>
    </>
  );
}
